// extracted by mini-css-extract-plugin
module.exports = {"baseStyle":"FileDrop_baseStyle__34rH4","activeStyle":"FileDrop_activeStyle__2Uh4D"};